import { ModalWrapper } from 'src/components/ModalWrapper';
import jackpotBanner from './images/jackpotBanner.webp';
import { useModalContext } from 'src/hooks/useModalContext';
import {
  AvailableBonusesTransactionsStatuses,
  BonusTransaction,
  GameData,
  getCurrencyIcon,
  useGetShortBalance,
  useUpdateBonusStatus
} from 'react-easyrocket';
import { parseBalanceAmount } from './utils';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import classNames from 'classnames';
import { useGetGameId } from './hooks/useGetGameId';
import { GameBlock } from './components/GameBlock';

export const JackpotsWin = () => {
  const {
    data: { bonusCasino }
  } = useGetShortBalance();
  const gameId = useGetGameId();
  const bonusWager = bonusCasino > 0;

  const { modalProps, closeModal } = useModalContext<{
    jackpot: BonusTransaction;
    game: GameData;
    isLoadingGame: boolean;
  }>();
  const { jackpot, game, isLoadingGame } = modalProps;
  const { t } = useTranslation();
  const { mutateAsync: updateBonusStatus, isLoading } = useUpdateBonusStatus();

  const isJackpotWager = jackpot?.wager > 0;

  const updateBonus = async (status: AvailableBonusesTransactionsStatuses) => {
    closeModal();
    updateBonusStatus({ bonus_id: jackpot?.id, status });
  };

  const handleAddToQueue = () => updateBonus('Queue');
  const handleActivateBonus = () => {
    isJackpotWager && updateBonus('Activated');
    closeModal();
  };
  const handleRejectBonus = () => updateBonus('Rejected');

  const showAddToQueue = bonusWager && isJackpotWager;

  return (
    <ModalWrapper
      showCross={false}
      isTransparentBg
      containerClassName="relative w-fit 768:pt-[400px] pt-[200px] 768:px-[38px]">
      <section className="relative z-10 rounded-[16px] flex flex-col items-center bg-JACKPOT_WIN_MODAL_BG bg-cover bg-center bg-no-repeat px-4 py-3 768:pt-5 768:px-16 768:pb-8">
        <h2 className="text-jm_title text-lg font-medium pb-2">{t('jackpotsWinModal.title')}</h2>
        <p className="text-jm_amount text-6xl font-bold pb-5">
          {getCurrencyIcon(jackpot?.currency)}

          {jackpot?.amount ? parseBalanceAmount(jackpot?.amount, jackpot?.currency) : null}
        </p>
        <GameBlock
          game={game}
          isLoadingGame={isLoadingGame}
          isShowButtons={isJackpotWager && !gameId && !bonusWager}
          updateBonus={updateBonus}
        />
        <div className="w-full min-w-[308px] 768:min-w-[464px] flex flex-col gap-5">
          <Button mode="button-primary" className="min-w-full" onClick={handleActivateBonus}>
            {t('jackpotsWinModal.claimAndPlay')}
          </Button>

          {(showAddToQueue || isJackpotWager) && (
            <div
              className={classNames(
                'flex gap-2.5',
                showAddToQueue && isJackpotWager ? 'flex-row flex-wrap' : 'flex-col'
              )}>
              {showAddToQueue && (
                <Button
                  mode="button-secondary"
                  onClick={handleAddToQueue}
                  disabled={isLoading}
                  className="flex-grow flex-shrink basis-[48%] text-nowrap max-w-full">
                  {t('jackpotsWinModal.addToQueue')}
                </Button>
              )}
              {isJackpotWager && (
                <Button
                  mode="button-secondary"
                  onClick={handleRejectBonus}
                  className="flex-grow flex-shrink basis-[48%] text-nowrap max-w-full">
                  {t('jackpotsWinModal.declain')}
                </Button>
              )}
            </div>
          )}
        </div>
      </section>
      <img
        src={jackpotBanner}
        alt="Jackpot banner"
        className="absolute 768:top-[0px] 375:top-[-10px] top-2 375:right-0 right-2 z-0 375:w-full w-[95%]"
      />
    </ModalWrapper>
  );
};
